import React from 'react'

class StopReasonPopup extends React.Component {
  constructor(props) {
    super(props)
    this.state = { selectedId: null, note: '' }
  }

  render() {
    const { eventType, reasons, onCancel, onConfirm } = this.props
    const { selectedId, note } = this.state
    const title = eventType === 'break' ? 'Wybierz powód przerwy' : 'Wybierz powód awarii'
    const selectedReason = reasons.find(reason => reason.id === selectedId)
    const noteMissing = selectedReason && selectedReason.require_note && !note.trim()
    const canConfirm = selectedId && !noteMissing

    return (
      <div className="popup-overlay">
        <div className="popup-card">
          <h4>{title}</h4>
          <p className="popup-req">* wybór powodu jest obowiązkowy</p>
          <div className="reason-list">
            {reasons.map(reason => (
              <div key={reason.id} className="reason" onClick={() => this.setState({ selectedId: reason.id })}>
                <div className={'radio' + (selectedId === reason.id ? ' checked' : '')}>
                  {selectedId === reason.id && <i />}
                </div>
                {reason.name}
              </div>
            ))}
            {!reasons.length && <p>Brak zdefiniowanych powodów tego typu.</p>}
          </div>
          <div className="field">
            <label>NOTATKA{selectedReason && selectedReason.require_note ? ' (wymagana)' : ' (opcjonalnie)'}</label>
            <textarea
              rows="3"
              value={note}
              onChange={e => this.setState({ note: e.target.value })}
              placeholder="Dodatkowe informacje..."
            />
          </div>
          <div className="popup-actions">
            <button type="button" className="secondary" onClick={onCancel}>Anuluj</button>
            <button type="button" disabled={!canConfirm} onClick={() => onConfirm(selectedId, note)}>Potwierdź</button>
          </div>
        </div>
      </div>
    )
  }
}

export default StopReasonPopup
